export default __webpack_public_path__ + "static/media/mockExamStudent.9ca44e97.webp";